import firebase from 'firebase';
const firebaseConfig = {
  apiKey: "AIzaSyBUbWM4z6YlifB-uz-rSllrT-qu7fXsvY0",
  authDomain: "profitchain-a7715.firebaseapp.com",
  databaseURL: "https://profitchain-a7715-default-rtdb.firebaseio.com",
  projectId: "profitchain-a7715",
  storageBucket: "profitchain-a7715.firebasestorage.app",
  messagingSenderId: "158514907054",
  appId: "1:158514907054:web:8c5ed871a702ab55bf2a3f"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();
firebase.firestore().settings({ timestampsInSnapshots: true })

export const f = firebase;
export const database = firebase.database();
export const storage = firebase.storage();
export const auth = firebase.auth();
export default firebase.firestore()